import AppProjectPage from "../app"
import ProjectPageSettingsManager from "../settings/settings-manager"

// const debug = "page_toggleLastUpdatedBy"
const debug = false

export default function page_toggleLastUpdatedBy(value: boolean) {
    const app: AppProjectPage = gd.getMainApp() as AppProjectPage
    const settings: ProjectPageSettingsManager = app.settings as ProjectPageSettingsManager

    const newValue       = !_.isNil(value) ? value : !settings.showLastUpdatedBy
    const isValueChanged = settings.showLastUpdatedBy !== newValue
    settings.showLastUpdatedBy = newValue

    debug && console.log(debug, 'process', value, newValue, settings.showCreatedBy)

    if (isValueChanged) {
        app.render()
    }
}